import experimentState, {ApplicationState} from './state/experimentState';

import React from 'react';
import ReconnectingWebSocket from 'reconnecting-websocket';
import {recordEvent} from "./utils"

class Backend {
    constructor() {
        this.init()
        window.ws_init = this.init
    }

    init() {
        var ws_scheme = window.location.protocol === "https:" ? "wss" : "ws";
        var hostname_mapping = {
            "localhost": "localhost:41995",
            "192.168.2.17": "192.168.2.17:41995",
            "192.168.1.79": "192.168.1.79:41995"
        }
        let hostname = window.location.hostname;
        if (hostname_mapping.hasOwnProperty(hostname)) {
            hostname = hostname_mapping[hostname];
        }
        var ws_path = ws_scheme + '://' + hostname + "/chat/stream/";
        console.log("Connecting to " + ws_path);
        this.skt = new ReconnectingWebSocket(ws_path);
        this.skt.onmessage = this.onmessage
        let params = new URLSearchParams(window.location.search);
        var param_uuid = params.get("uuid")
        this.skt.onopen = () => {
            this.actionRegister(param_uuid)
        }

        window.skt = this.skt
        window.param_uuid = param_uuid
        window.actionRegister = this.actionRegister

        this.timeoutId = null;

    }

    onmessage(message) {
        var data = JSON.parse(message.data);
        console.log("message received from backend", data);
        // Handle errors
        if (data.error) {
            if (data.error === "ROOM_INVALID") {
                experimentState.setApplicationState(ApplicationState.APP_INVALID_LINK)
            } else {
                alert(data.error);
            }
            return;
        } else if (data.join) {
            experimentState.setRoomId(data.join)
            experimentState.setChannel(data.title)
            experimentState.setUser(data.username)
            // experimentState.setApplicationState(ApplicationState.APP_PRE_PHASE3)
            if (experimentState.application_state === ApplicationState.APP_LOADING) {
                experimentState.setApplicationState(ApplicationState.APP_INFORMED_CONSENT)
            }
            experimentState.setExperimentParams(data.params)
        } else if (data.typing) {
            experimentState.setUserTyping(data.typing, data.status)
        } else if (data.finish) {
            experimentState.setApplicationState(ApplicationState.APP_FINISH)
        } else if (data.questionFinish && experimentState.experimentParams.admin) {
            // only do if admin.
            if (data.expiry) {
                experimentState.incrQuestionsExpired()
            } else {
                experimentState.incrQuestionsFinished()
                if (experimentState.sendingQuestions > 0) {
                    setTimeout(backend.actionSendQuestion.bind(this), Math.floor((Math.random() * 3000) + 1000))
                }
            }
        } else if (data.questionFinish) {
        } else if (data.message || data.msg_type != 0) {
            if (!data.replay) {
                recordEvent({
                    type: "msg",
                    user: data.username === "Interviewer" ? data.username : "Participant",
                    run_id: data.run_id,
                    question_id: data.question_id,
                    challenge: data.challenge,
                    challenge_params: data.challenge_param
                })
            }
            switch (data.msg_type) {
                case 0:
                    experimentState.newMessage({
                        message: data.message,
                        user: data.username === "Interviewer" ? data.username : "Participant",
                        is_me: data.is_me,
                        now: performance.now()
                    })
                    if (data.username === "Interviewer") {
                        experimentState.setPressedSend(false)
                    }
                    break;
                case 1:
                    // User joined room
                    if (!experimentState.experimentParams.admin) {
                        return
                    }
                    experimentState.newMessage({
                        user: data.username === "Interviewer" ? data.username : "Participant",
                        message: data.message,
                        type: "warning"
                    })
                    break;
                case 2:
                    // User joined room
                    experimentState.newMessage({
                        user: data.username === "Interviewer" ? data.username : "Participant",
                        message: data.message,
                        type: "danger"
                    })
                    break;
                case 3:
                    // User joined room
                    experimentState.newMessage({
                        user: data.username === "Interviewer" ? data.username : "Participant",
                        message: data.message,
                        type: "muted"
                    })
                    break;
                case 4:
                    // User joined room
                    experimentState.newMessage({
                        user: data.username === "Interviewer" ? data.username : "Participant",
                        message: `${data.username} joined the room!`,
                        type: "muted"
                    })
                    break;
                case 5:
                    // User left room
                    experimentState.newMessage({
                        user: data.username === "Interviewer" ? data.username : "Participant",
                        message: `${data.username} left the room!`,
                        type: "muted"
                    })
                    break;
                // case 6:
                //     break;
                case 7: // Question Id
                    if (!experimentState.experimentParams.admin) {
                        experimentState.setQuestionStart(performance.now());
                        experimentState.setQuestionExpired(false);
                    }

                    let [qid, runid, text, qtype, answer, cr] = experimentState.questions[data.run_id]
                    console.log(data, qid, runid, cr)
                    if (cr && !experimentState.experimentParams.admin) {
                        // console.log(data.challenge,"cr is ",cr,"but we are not setting it")
                        experimentState.setChallengeState(cr)
                    } else {
                        // console.log(data.challenge,"cr is ",cr,"but we are not setting it")
                        experimentState.setChallengeState(null)
                    }
                    experimentState.newMessage({
                        user: "Interviewer",
                        question_id: qid,
                        type: "question",
                        run_id: data.run_id,
                        now: performance.now()
                    })
                    experimentState.addEvent({
                        user: "Interviewer",
                        question_id: qid,
                        type: "question",
                        run_id: data.run_id,
                        now: performance.now(),
                        challenge: cr.challenge,
                        challenge_params: cr,
                        answer: answer,
                        qtype: qtype,
                    })
                    break;

                default:
                    console.log("Unsupported message type!");
                    return;
            }
        } else {
            console.log(data, "Cannot handle message!");
        }
    }

    actionRegister(uuid) {
        this.skt.send(JSON.stringify(
            {
                command: "join",
                room: uuid,
            }
        ));
    }

    actionSendMessage(username, message) {
        this.skt.send(JSON.stringify({
            "command": "send",
            "room": experimentState.room_id,
            "message": message,
            "events": experimentState.events,
            "timestamp": performance.now()
        }));

        experimentState.deleteEvents();
    }

    actionSendQuestion() {
        if (experimentState.sendingQuestions <= 0) {
            return
        }

        experimentState.decrSendingQuestions()
        let [_1, question_id, msg, _2, _3, cr] = experimentState.questions[experimentState.runId]
        backend.skt.send(JSON.stringify({
            "command": "question",
            "room": experimentState.room_id,
            "question_id": question_id,
            "run_id": experimentState.runId,
            "challenge": cr.challenge,
            "challenge_params": cr
        }));
        experimentState.incrRunId()
    }

    actionSendQuestionFinish(expiry) {
        this.skt.send(JSON.stringify({
            "command": "questionFinish",
            "room": experimentState.room_id,
            "expiry": expiry
        }))
    }

    actionSendFinish(data) {
        this.skt.send(JSON.stringify({
            "command": "finish",
            "room": experimentState.room_id,
        }))
    }

    actionRefreshTyping(user) {

        var that = this;
        if (that.timeoutId == null) {
            // we are not already typing
            that.actionSendTyping(user, true);
            that.timeoutId = setTimeout(function () {
                that.actionSendTyping(user, false);
            }, 5000)
        } else {
            // we are already typing
            clearTimeout(that.timeoutId);
            this.timeoutId = setTimeout(function () {
                that.actionSendTyping(user, false);
            }, 5000)
        }
    }

    actionSendTyping(user, status) {
        this.skt.send(JSON.stringify({
            "command": "typing",
            "status": status,
            "room": experimentState.room_id
        }));
    }
}

const backend = new Backend();

export default backend;